export default class NumberSeparator {

  public static getIntegerDecimalValues(value: number) {
    const integerValue = Math.floor(value);
    const decimalValue = value % 1;
    return { integerValue, decimalValue };
  }
}
